module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Reminder")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email address",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('span', [(!_vm.$v.credentials.email.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n\t\t\t\t\t\tField is required.\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.email.email) ? _c('span', {
    staticClass: "el-form-item__error",
    attrs: {
      "disabled": _vm.app.isLoading
    }
  }, [_vm._v("\n\t\t\t\t\t\tMust be a valid email.\n\t\t\t\t\t")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.sendReminder()
      }
    }
  }, [_vm._v("Send Reminder")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44fe027b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Reminder.vue
// module id = 630
// module chunks = 1